import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import ProductTypeForm from "./ProductTypeForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { productTypeValidationForm } from "../../utils/validationSchemas";

const EditProductType = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
        unit: {
          id: data?.data?.unit,
          name: data?.data?.unit,
        },
      };
    },
  });

  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <ProductTypeForm
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
    </FormLayout>
  );
};

export default EditProductType;
